import { createStore } from "vuex";

export default createStore({
  state: {
    interfacePath: "", // 储存接口路径的数据
    loginRecord: "", // 储存login接口返回的数据
  },
  getters: {},
  mutations: {
    // 储存接口路径的数据
    GET_InterfacePath(state, data) {
      state.interfacePath = data;
    },
    // 储存login接口返回的数据
    GET_RES(state, data) {
      state.loginRecord = data;
    },
  },
  actions: {},
  modules: {},
});
